module.exports = __webpack_public_path__ + "static/produksiyon-hizmeti-82c17134a7fdf7b695b74adca04551bc.webp";